export const iconFontAwesomeAccessibilityPhoneVolume = (
	<i className="fa-solid fa-phone-volume"></i>
);
